import { lazyRouteComponent, createRoute } from '@tanstack/react-router';

import { processIncomingMobilityRoute } from '../route';

export const processIncomingMobilityPaymentOrderRoute = createRoute({
	getParentRoute: () => processIncomingMobilityRoute,
	path: '/2-payment-orders',
	component: lazyRouteComponent(
		() => import('./ProcessIncomingMobilityRecurringPaymentsPage'),
		'ProcessIncomingMobilityRecurringPaymentsPage',
	),
});
